import { render, staticRenderFns } from "./Cloud.vue?vue&type=template&id=157bd0a8&scoped=true"
import script from "./Cloud.vue?vue&type=script&lang=js"
export * from "./Cloud.vue?vue&type=script&lang=js"
import style0 from "./Cloud.vue?vue&type=style&index=0&id=157bd0a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157bd0a8",
  null
  
)

export default component.exports